import { Link } from "react-router-dom";
import "./ClosingCTA.css";

const ClosingCTA = () => {
  return (
    <section className="cta-section">
      <div className="container cta-wrapper">

        <h2>
          Build smarter, market better, and move faster.
        </h2>

        <p>
          Whether you are exploring AI adoption, refining your market strategy,
          building digital capabilities, or shaping a new venture, Karma & Delta
          can help you define the right path.
        </p>


        <Link to="/contact" className="cta-button">
          Start a Conversation
        </Link>

      </div>
    </section>
  );
};

export default ClosingCTA;